import * as TemplateTypes from 'types/template.types';
import BaseScene from './base';
import { showInterstitial } from 'src/util/ad-util';

class InterstitialScene extends BaseScene {
    constructor(){
        super({ 
            key: TemplateTypes.Scene.INTERSTITIAL_SCENE, 
        });
    }

    async create(){
        document.body.style.background = '#000000';
        await showInterstitial();
        this.exit('Menu');
    }
}

export default InterstitialScene;